import { render, staticRenderFns } from "./lookDownFile.vue?vue&type=template&id=6cd985f2&scoped=true"
import script from "./lookDownFile.vue?vue&type=script&lang=js"
export * from "./lookDownFile.vue?vue&type=script&lang=js"
import style0 from "./lookDownFile.vue?vue&type=style&index=0&id=6cd985f2&prod&lang=scss&scoped=true"
import style1 from "./lookDownFile.vue?vue&type=style&index=1&id=6cd985f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd985f2",
  null
  
)

export default component.exports